<template>
  <HomeHeroSection v-if="section.type === 'hero'" :section="section" />
  <ConfigurableCarousel v-else-if="isCarousel" :section="section" :default-images="[]" :variant="carouselVariant" />
  <CommercialHomeSections v-else :sections="[section]" />
</template>

<script>
import HomeHeroSection from './HomeHeroSection.vue';
import ConfigurableCarousel from './ConfigurableCarousel.vue';
import CommercialHomeSections from './CommercialHomeSections.vue';
export default { name: 'HomeSectionRenderer', components: { HomeHeroSection, ConfigurableCarousel, CommercialHomeSections }, props: { section: { type: Object, required: true } }, computed: { isCarousel() { return /^carousel_[123]$/.test(this.section.type); }, carouselVariant() { return Number(this.section.type.replace('carousel_', '')) || 1; } } };
</script>
